// extracted by mini-css-extract-plugin
module.exports = {"contentcard":"ContentCard_contentcard__n3TSy","title":"ContentCard_title__2cHcv"};